import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { CandidateSessionService } from './candidate-session.service';

/**
 * Blocks temporary (candidate) users from the knowledge base — the org-structure node/folder tree
 * (`/node`, `/node-fullscreen`) and the QR `jumpto` resolver that forwards into it.
 *
 * <p>Client decision: temporary users may only use their "my *" areas (Home, My Work, My E-Learning,
 * My Surveys, …) and must not browse the knowledge base. Because the `/node` route is not feature-gated
 * and `SYSTEM_U0` (the temp-user role) is shared with regular employees, the cleanest lever is this
 * single choke point keyed off the candidate session — every entry point into the tree (topbar search,
 * QR jumpto, breadcrumb, direct URL) routes through here, so one guard covers them all.</p>
 *
 * <p>Candidate detection uses {@link CandidateSessionService} (the `candidate:true` JWT claim), the
 * app-wide temp-user signal. Frontend-only, matching the app's frontend-gating convention; candidates
 * are simply redirected Home rather than shown a denial page.</p>
 */
export const blockCandidateFromKnowledgeBaseGuard: CanActivateFn = (): boolean | UrlTree => {
  const candidateSession = inject(CandidateSessionService);
  const router = inject(Router);

  if (candidateSession.isActive()) {
    return router.createUrlTree(['/']);
  }
  return true;
};
